import { request } from '@umijs/max';

export async function queryCarouselList(
  params?: any,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/carousel', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function addCarousel(
  data: API.CarouselInfoVO,
  options?: { [key: string]: any },
) {
  return request<any>('/api/v1/carousel', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

export async function updateCarousel(
  id: number,
  data: API.CarouselInfoVO,
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/carousel/${id}`, {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

export async function removeCarousel(
  id: number,
  options?: { [key: string]: any },
) {
  return request<any>(`/api/v1/carousel/${id}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}
